import React from 'react';

import { t } from '../../services/i18nService';
import chromeAppService from '../../services/ChromeAppService';
import sessionReader from '../../store/readHelpers/SessionReader';
import OptionsTopBar from './OptionsTopBar';
import Confirmation from './Confirmation';

import styles from './options.scss';

class OptionsFileDeliveryChromeApp extends React.Component {
    state = {
        deliverBlank: false,
        requireInvigilatorPassword: sessionReader.testUsesInvigilatorPassword(),
    };

    toggleDeliverBlank = () => {
        this.setState({
            deliverBlank: !this.state.deliverBlank,
        });
    };

    actionHandler = () => {
        chromeAppService.sendSaveFileMessage(this.state.deliverBlank);
    };

    render() {
        const mainButtonText = t('options.fileDeliveryChromeAppButtonText');
        const contentChildren = (
            <p className={styles.toggleDeliverBlank}>
                <input
                    id="toggleDeliverBlank"
                    type="checkbox"
                    checked={this.state.deliverBlank}
                    onChange={this.toggleDeliverBlank}
                />
                <label htmlFor="toggleDeliverBlank">
                    {t('options.fileDeliveryDeliverBlank')}
                </label>
            </p>
        );

        return (
            <div>
                <OptionsTopBar title={t('options.fileDelivery')} showOptionsButton />
                <div className={styles.mainContentArea} role="main">
                    <Confirmation
                        contentChildren={contentChildren}
                        text={t('options.fileDeliveryChromeAppExplain')}
                        mainButtonText={mainButtonText}
                        actionHandler={this.actionHandler}
                        requireInvigilatorPassword={this.state.requireInvigilatorPassword}
                    />
                </div>
            </div>
        );
    }
}

export default OptionsFileDeliveryChromeApp;
